import { render } from "./property-pop3d.vue?vue&type=template&id=490ef353"
import script from "./property-pop3d.js?vue&type=script&lang=js"
export * from "./property-pop3d.js?vue&type=script&lang=js"

import "./property-pop3d.vue?vue&type=style&index=0&id=490ef353&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__